export default __webpack_public_path__ + "static/media/fire&chamallow.10f35a52.jpg";